import { defineNuxtRouteMiddleware, useRoute, useNuxtApp, useCookie } from '#imports'

export default defineNuxtRouteMiddleware(async () => {
	const { public: config } = useRuntimeConfig()
	if (config.env !== 'prod') return

	const app = useNuxtApp()
	const store = app.$store
	await store.restored
	const route = useRoute()
	const auth = useCookie('auth').value

	if (!auth || !store.state.auth) {
		return
	}

	const company = await store.dispatch('company/retrieve', { companyId: store.getters.companyId })
	const companyStore = await store.dispatch('stores/list', { companyId: store.getters.companyId })
	const referral = await store.dispatch('referralProgram/get', {
		companyId: store.getters.companyId,
	})
	const loyalty = await store.dispatch('loyaltyChallenge/list', {
		companyId: store.getters.companyId,
	})

	const _hsq = (window._hsq = window._hsq || [])
	let storeProvider = ''
	if (Object.keys(companyStore).length > 0) {
		storeProvider = companyStore.provider === 1 ? 'shopify' : 'prestashop'
	}
	_hsq.push([
		'identify',
		{
			email: company.email,
			ID_Loyoly: company.id,
			company: company.name,
			firstname: company.first_name,
			lastname: company.last_name,
			is_free_trials: String(company.plan_id === 2),
			langue: company.language,
			phone: company.phone_number,
			website: company.website_url,
			is_suspended: String(company.is_suspended && !company.keep_account),
			has_referral: String(referral?.enable === true),
			has_loyalty: String(
				loyalty.filter((cha) => cha.type === 0 && cha.enable === true).length !== 0,
			),
		},
	])

	_hsq.push(['setPath', route.path])
	_hsq.push(['trackPageView'])

	try {
		window.jimo.push([
			'do',
			'session:reset',
			[
				`${company.id}`,
				() => {
					window.jimo.push(['do', 'trigger-badge:find'])
					window.jimo.push(['set', 'user:id', [company.id]])
					window.jimo.push(['set', 'user:email', [company.email]])
					window.jimo.push(['set', 'user:name', [company.name]])
					window.jimo.push([
						'set',
						'user:attributes',
						[
							{
								has_instagram: !!company.insta_account,
								has_twitter: !!company.twitter_account,
								has_tiktok: !!company.tiktok_account,
								has_referral: referral?.enable === true,
								is_free_trials: company.plan_id === 2,
								is_suspended: company.is_suspended,
								langue: company.language,
								has_store: Object.keys(companyStore).length > 0,
								store_provider: storeProvider,
								has_loyalty:
									loyalty.filter((cha) => cha.type === 0 && cha.enable === true)
										.length !== 0,
							},
						],
					])
				},
			],
		])
		window.jimoInit()
	} catch {
		// Silently ignore errors from the Jimo integration
	}

	window.Intercom('boot', {
		api_base: 'https://api-iam.intercom.io',
		app_id: 'vmqdeq4s',
		name: company.first_name,
		email: company.email,
		user_id: company.id,
		is_free_trials: company.plan_id === 2,
		langue: company.language,
		has_instagram: !!company.insta_account,
		has_store: Object.keys(companyStore).length > 0,
		store_provider: storeProvider,
		has_twitter: !!company.twitter_account,
		has_tiktok: !!company.tiktok_account,
		has_referral: referral?.enable === true,
		has_loyalty: loyalty.filter((cha) => cha.type === 0 && cha.enable === true).length !== 0,
		is_suspended: company.is_suspended,
	})
	window.Intercom('update')

	// eslint-disable-next-line no-undef
	ska(function (skalin) {
		skalin.identity({ id: company.id })
	})
})
